module.exports = __webpack_public_path__ + "static/media/S (169).03ed80ec.jpg";